module.exports = __webpack_public_path__ + "static/media/panni.3f77a85a.svg";